import { render, staticRenderFns } from "./VIconFlag.vue?vue&type=template&id=3e9484a5&scoped=true"
import script from "./VIconFlag.vue?vue&type=script&lang=js"
export * from "./VIconFlag.vue?vue&type=script&lang=js"
import style0 from "./VIconFlag.vue?vue&type=style&index=0&id=3e9484a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9484a5",
  null
  
)

export default component.exports